export const TYPE_REDUCER = {
  EXAMPLE_ACTION: 'EXAMPLE_ACTION',
  SET_MODAL: 'SET_MODAL',
  SET_ATTRIBUTES: 'SET_ATTRIBUTES',
  SET_ACTIVE_ITEM: 'SET_ACTIVE_ITEM',
  SET_PRICE_INFO: 'SET_PRICE_INFO',
  SET_IS_SHORT_ID: 'SET_IS_SHORT_ID',
};

type PAGE_NAME_T = {
  home: string;
  Jeep2DoorJL: string;
  Jeep4DoorJL: string;
  JeepGladiator: string;
};
export const assetID: any = {
  '/Jeep2DoorJL': 'Jeep2DoorJL',
  '/Jeep4DoorJL': 'Jeep4DoorJL',
  '/JeepGladiator': 'JeepGladiator',
};

export const PAGE_NAME: PAGE_NAME_T = {
  home: '/',
  Jeep2DoorJL: '/Jeep2DoorJL',
  Jeep4DoorJL: '/Jeep4DoorJL',
  JeepGladiator: '/JeepGladiator',
};
export const URL_POST_QUERY = 'https://www.annasheffield.com/';
export let urlApp = `https://annasheffield.com/pages/the-stacking-suite-builder`;
export const THREEKIT_PARAMS = {
  threekitUrl: 'https://admin-fts.threekit.com/',
  authToken: process.env.THREEKIT_PREVIEW_PUBLIC_TOKEN,
  assetId: process.env.THREEKIT_PREVIEW_ASSET_ID,
  // elementId: '',
  orgId: process.env.THREEKIT_PREVIEW_ORG_ID,
};

export type actualAttributesT = Record<AttributesT, string>;
export type stringDataParametersT = {
  [key: string]: {
    _img: string;
  };
};

export const warningShopInfo: any = {
  Tire: {
    hint: 'We recommend choosing 4 tires for a full set',
    min: 4,
  },
  Wheels: {
    hint: 'We recommend choosing 4 wheels for a full set',
    min: 4,
  },
};

export const staticStringOptionReplace = ['lift'];
export const stringDataParameters: stringDataParametersT = {
  //Lift
  Standart: {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  '2 inch lift': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  '4 inch lift': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  // Tire size
  '35"': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  '37"': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  // Wheel Color
  'Satin Black': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  'Gun Metal Gray': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  'Black with Machined Lip': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  Silver: {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  'Smoked Bronze': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  'Gloss White': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  'Machined Finish': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  // Bumper Width
  Stubby: {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
  'Full Width': {
    _img: 'https://www.quadratec.com/sites/default/files/styles/product_teaser/public/product_images/Quadratec-Baja-Xtreme-Gen-II-17x9-5x5-4.75-in-Backspace-Satin-Black-Bolt-On-Center-Cap.jpg',
  },
};
export const actualAttributes: actualAttributesT = {
  'Jeep Type': 'Jeep Type',
  'Paint color': 'Paint',
  Tire: 'Tire',
  Wheels: 'Wheels',
  'Front Bumper': 'Front Bumper',
  'Rear Bumper': 'Rear Bumper',
  'Front Fender': 'Front Fender',
  'Rear Fender': 'Rear Fender',
  Door: 'Door',
  Mirror: 'Mirror',
  'Hood Catcher': 'Hood Catcher',
  'Light Bar': 'Light Bar',
  'Side Steps': 'Side Steps',
};

export const cameraPositions: any = {
  'Jeep Type': undefined,
  'Paint color': undefined,
  Tire: 1,
  Wheels: 2,
  'Front Bumper': 0,
  'Rear Bumper': 4,
  'Front Fender': 0,
  'Rear Fender': 4,
  Door: undefined,
  Mirror: undefined,
  'Hood Catcher': undefined,
  'Light Bar': undefined,
  'Side Steps': undefined,
};

export type AttributesT =
  | 'Jeep Type'
  | 'Paint color'
  | 'Tire'
  | 'Wheels'
  | 'Front Bumper'
  | 'Rear Bumper'
  | 'Front Fender'
  | 'Rear Fender'
  | 'Door'
  | 'Mirror'
  | 'Hood Catcher'
  | 'Light Bar'
  | 'Side Steps'
  | string;
export enum itemTypes {
  colorPicker = 'colorPicker',
  standartItem = 'standartItem',
}
export const dataLift: any = {
  'Wrangler JL': {
    'Standard': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': { img: '', id: 0 },
        'Hydro 7.0': { img: '', id: 0 },
        'Nitro 8.0': { img: '', id: 0 },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': { img: '', id: 0 },
        'Hydro 7.0': { img: '', id: 0 },
        'Nitro 8.0': { img: '', id: 0 },
      },
    },
    '2 inch': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Fox-2.0-IFP.jpg',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Hydro-7.0.jpg',
          id: 81405,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Nitro-8.0.jpg',
          id: 81404,
        },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81320,
        },
        'Hydro 7.0': { img: 'undefined', id: 81322 },
        'Nitro 8.0': { img: 'undefined', id: 81321 },
      },
    },
    '4 inch': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-2DR-RUB_4DR_NON-RUB_HYDRO_16400-0074_0.jpg',
          id: 255264,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-2DR-RUB_4DR_NON-RUB_NITRO_16400-0075_0.jpg',
          id: 255275,
        },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-2DR-NON-RUB_HYDRO_16400-0078.jpg',
          id: 256126,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-2DR-NON-RUB_NITRO_16400-0079.jpg',
          id: 256127,
        },
      },
    },
  },
  'Wrangler JL Unlimited': {
    'Standard': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': { img: '', id: 0 },
        'Hydro 7.0': { img: '', id: 0 },
        'Nitro 8.0': { img: '', id: 0 },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': { img: '', id: 0 },
        'Hydro 7.0': { img: '', id: 0 },
        'Nitro 8.0': { img: '', id: 0 },
      },
    },
    '2 inch': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Fox-2.0-IFP-jl-unlimited.jpg',
          id: 81400,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Hydro-7.0-jl-unlimited.jpg',
          id: 81403,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Nitro-8.0-jl-unlimited.jpg',
          id: 81402,
        },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Fox-2.0-IFP-jl-unlimited_0.jpg',
          id: 81310,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Hydro-7.0-jl-unlimited_0.jpg',
          id: 81312,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/Quadratec-Maximum-Duty-2.5in-Coil-Spring-Suspension-Lift-Kit-Nitro-8.0-jl-unlimited_0.jpg',
          id: 81311,
        },
      },
    },
    '4 inch': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-4DR-RUB_HYDRO_16400-0076.jpg',
          id: 255277,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-4DR-RUB_NITRO_16400-0077.jpg',
          id: 256132,
        },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-2DR-RUB_4DR_NON-RUB_HYDRO_16400-0074.jpg',
          id: 255264,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JL-2DR-RUB_4DR_NON-RUB_NITRO_16400-0075.jpg',
          id: 255275,
        },
      },
    },
  },
  Gladiator: {
    'Standard': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': { img: '', id: 0 },
        'Hydro 7.0': { img: '', id: 0 },
        'Nitro 8.0': { img: '', id: 0 },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': { img: '', id: 0 },
        'Hydro 7.0': { img: '', id: 0 },
        'Nitro 8.0': { img: '', id: 0 },
      },
    },
    '2 inch': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_2.5IN_Lift_Kit_JT-RUB_HYDRO_16400-0083.jpg',
          id: 256134,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_2.5IN_Lift_Kit_JT-RUB_NITRO_16400-0084.jpg',
          id: 256129,
        },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_2.5IN_Lift_Kit_JT-NON-RUB_HYDRO_16400-0085.jpg',
          id: 256136,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_2.5IN_Lift_Kit_JT-NON-RUB_NITRO_16400-0086.jpg',
          id: 256128,
        },
      },
    },
    '4 inch': {
      Rubicon: {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JT-RUB_HYDRO_16400-0087.jpg',
          id: 256135,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JT-RUB_NITRO_16400-0088.jpg',
          id: 256130,
        },
      },
      'Sport/Sahara': {
        'Fox 2.0 Performance Series IFP': {
          img: 'undefined',
          id: 81401,
        },
        'Hydro 7.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JT-NON-RUB_HYDRO_16400-0089.jpg',
          id: 256131,
        },
        'Nitro 8.0': {
          img: 'https://quadratecbeta-z9cen.ondigitalocean.app/static/media/SKJ_Quad_3.5IN_Lift_Kit_JT-NON-RUB_NITRO_16400-0091.jpg',
          id: 256133,
        },
      },
    },
  },
};
export const arApiNameJeeps: any = {
  Jeep2DoorJL: 'Jeep 2 door JL',
  Jeep4DoorJL: 'Jeep 4 door JL',
  JeepGladiator: 'Jeep Gladiator',
};
